import { IPushGroupWithLinksAndStats } from "@novel/shared/interfaces/PushGroup";
import { NovelVendorSubReducer } from "@vendor-portal/redux/vendorTypedRedux";

export interface ILinkReducerState {
    isLoading: boolean;
    data: IPushGroupWithLinksAndStats[];
}

const initialState: ILinkReducerState = {
    isLoading: true,
    data: [],
};

export const linkReducer: NovelVendorSubReducer<ILinkReducerState> = (
    state = initialState,
    action,
) => {
    switch (action.type) {
        case "LOADING_LINKS": {
            return {
                ...state,
                isLoading: true,
            };
        }

        case "ERROR_LOADING_LINKS": {
            return {
                ...state,
                isLoading: false,
            };
        }

        case "LOADED_LINKS": {
            return {
                ...state,
                data: action.payload.pushGroupsWithLinksAndStats,
                isLoading: false,
            };
        }

        default:
            return state;
    }
};
